"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateConstants = exports.ContractEvents = exports.setVersionData = exports.Versions = exports.SharedConstants = void 0;
const mainnet_1 = require("./chainConfig/mainnet");
const goerli_1 = require("./chainConfig/goerli");
const sepolia_1 = require("./chainConfig/sepolia");
const utils_1 = require("./utils");
exports.SharedConstants = Object.freeze({
    EIP2930_BLOCK: 12244000,
    EIP1559_BLOCK: 12965000,
});
exports.Versions = ["v2"];
function setVersionData(chainId, version, mock) {
    let versionData;
    switch (chainId) {
        case 1n:
        case 31337n:
            versionData = (0, utils_1.deepCopyObject)(mainnet_1.versionDataMainnet);
            if (mock) {
                updateConstants(versionData, version, mainnet_1.versionOverrideMainnetMock[version]);
            }
            break;
        case 5n:
        case 31341n:
            versionData = (0, utils_1.deepCopyObject)(goerli_1.versionDataGoerli);
            if (mock) {
                updateConstants(versionData, version, goerli_1.versionOverrideGoerliMock[version]);
            }
            break;
        case 11155111n:
            versionData = (0, utils_1.deepCopyObject)(sepolia_1.versionDataSepolia);
            if (mock) {
                updateConstants(versionData, version, sepolia_1.versionOverrideSepoliaMock[version]);
            }
            break;
        default:
            throw new Error(`Unsupported chainId: ${chainId}`);
    }
    return versionData;
}
exports.setVersionData = setVersionData;
exports.ContractEvents = Object.freeze({
    QueryInitiatedOnchain: "QueryInitiatedOnchain",
    QueryFulfilled: "QueryFulfilled",
});
/// Update constants using the same nested object structure as the versionData variable.
/// Pass the updateObject in as an override when initializing Axiom.
function updateConstants(versionData, version, updateObject) {
    const versionUpdateObject = {
        [version]: updateObject,
    };
    return updateConstantsRecursive({ ...versionData }, versionUpdateObject);
}
exports.updateConstants = updateConstants;
function updateConstantsRecursive(versionMem, updateMem) {
    const keys = Object.keys(updateMem);
    for (const key of keys) {
        if (versionMem[key] === undefined) {
            console.log("versionData does not have key", key);
            continue;
        }
        if (typeof updateMem[key] !== "object") {
            versionMem[key] = updateMem[key];
            continue;
        }
        updateConstantsRecursive(versionMem[key], updateMem[key]);
    }
    return versionMem;
}
//# sourceMappingURL=constants.js.map